import { OrderType } from 'types/OrderType';
import { CountriesType, LocationType } from 'types/UFOTypes';
import { MOBILE_APPOINTMENT_TYPE } from './constantValues';

export interface CommonPricesParamsType {
  mode: LocationType;
  fleet_id: string;
  provider_id: string;
  price_date?: string;
  country_code?: CountriesType;
  state?: string;
  city?: string;
  zip_code?: string;
}

export const getCommonOrderPricesParams = (order: OrderType, isDealer: boolean | null) => {
  const isMobile = order?.additional_information.appointment_type === MOBILE_APPOINTMENT_TYPE;
  const params = {
    mode: isDealer ? 'provider' : ('fleet' as LocationType),
    provider_id: order?.provider_id ?? '',
    fleet_id: order?.orderer_id ?? '',
    country_code: (order?.provider_location_core.customer_country as CountriesType) || 'US', // tires endpoint needs country code on upper
    state: isMobile ? order?.provider_location_core.customer_state : undefined,
    city: isMobile ? order?.provider_location_core.customer_city : undefined,
    zip_code: isMobile ? order?.provider_location_core.customer_zip : undefined,
  };
  return params;
};
